import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import { FC } from 'react';
import { AllProductProps } from '../allProductsStats/types';
import CaseListing from '../caseListing';
import DrillDownPieChart from '../drillDownPieChart';

const AllProductDoctorStats: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData, drug }): JSX.Element => {

  return (
    <div>
      <div>
        {/* <AuthMaunfacturerSubHeader /> */}
        {statisticsData && (
          <CaseFilter
            defaultQueryParams={queryParams}
            updateQueryParams={updateQueryParamsAndCallAPI}
            drug={drug}
          />
        )}
        {statisticsData && queryParams && (
          <CaseVolume startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
            drug={drug} buttonShows={true} showPractice={true} />
        )}
        <div className='row'>
          <div className={"col-12 col-md-6 col-sm-12"}>
            {statisticsData &&
              <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />}
          </div>
          <div className="col-12 col-lg-6 col-sm-12">
            {statisticsData && statisticsData.data &&
              <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
            }
          </div>
          <div className="col-12 col-lg-6 col-sm-12">
            {statisticsData && statisticsData.data ?
              <DrillDownPieChart pieChartObject={statisticsData.data.icd_data} title={'Top 10 ICD Codes'} />
              : null
            }
          </div>
          <div className={"col-12 col-md-6 col-sm-12"}>
            <CustomPieChart title={"Cases By Submission Mode"} pieChartObject={statisticsData.data.mos} />
          </div>
        </div>
        {statisticsData && statisticsData.data ?
          <CaseListing drug={drug} queryParams={queryParams} caseListing={statisticsData.data.case_listing} />
          : null
        }
      </div>
    </div>)
}
export default AllProductDoctorStats;